var poll_default = {
  "fontElementMap": "fVsPM",
  "container": "KBAzC",
  "fullscreen": "of7kr",
  "background_overlay": "e0wQB",
  "with_image": "_9WIjB",
  "options": "ZzSHy",
  "webview": "dQyre",
  "grid": "RxNw4",
  "option": "YWjvc",
  "cta_button": "YeDeT",
  "add_option": "PEw9r",
  "see_more": "WIfNS",
  "list": "nlZgd",
  "column": "-Jiy-",
  "additional_note": "xEjLy",
  "spinner": "I8Qwl",
  "spin": "xjPZr",
  "shown": "-RFdB",
  "error": "GD44u"
};
export {
  poll_default as default
};
//# sourceMappingURL=poll-scss.js.map
